import { Injectable } from "@angular/core";
import { LocalStorageProvider } from "../../shared/storage-provider/local-storage-provider";

@Injectable()
export class AuthHttpConfig {
  private tokenKey = "token";
  private refreshTokenKey = "refresh_token";
  private impersonateKey = "impersonate";
  private storageProvider = new LocalStorageProvider();

  constructor() {}

  public setImpersonatedUsername(username: string): void {
    this.storageProvider.set(this.impersonateKey, username);
  }

  public getImpersonatedUsername(): string {
    return this.storageProvider.get(this.impersonateKey);
  }

  public removeImpersonatedUsername(): void {
    this.storageProvider.remove(this.impersonateKey);
  }

  public getPrefixedToken(): string {
    return this.getToken() ? `Bearer ${this.getToken()}` : null;
  }

  public getToken(): string {
    return this.storageProvider.get(this.tokenKey);
  }

  public setToken(token: string): void {
    this.storageProvider.set(this.tokenKey, token);
  }

  public removeToken(): void {
    this.storageProvider.remove(this.tokenKey);
  }

  public getRefreshToken(): string {
    return this.storageProvider.get(this.refreshTokenKey);
  }

  public setRefreshToken(refreshToken: string): void {
    this.storageProvider.set(this.refreshTokenKey, refreshToken);
  }

  public removeRefreshToken(): void {
    this.storageProvider.remove(this.refreshTokenKey);
  }
}
